import { InventoryApi } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useInventoryTargets = (inventoryId?: string) =>
  useQuery({
    queryKey: [INVENTORIES_QUERY_KEYS.TARGET, inventoryId],
    queryFn: async () => {
      // enable handles this
      // eslint-disable-next-line
      const inventory = await InventoryApi.getInventoryTargets(inventoryId!)
      return inventory.data.item
    },
    enabled: !!inventoryId,
  })
